import { Box } from '@mui/material';
import OtpInput from 'react-otp-input';

import { AuthOtp } from '../../types/AuthOtp';

interface AuthenticationProps {
  codeForAuthentication: AuthOtp;
  setCodeForAuthentication: (type: AuthOtp) => void;
}

export const Authentication = ({
  codeForAuthentication,
  setCodeForAuthentication,
}: AuthenticationProps) => {
  const handleChange = (otp: string) => setCodeForAuthentication({ otp });

  return (
    <Box display="flex" gap="5px" mt="10px" mb="10px">
      <OtpInput
        inputStyle={{
          width: '100%',
          height: '56px',
        }}
        value={codeForAuthentication.otp}
        onChange={handleChange}
        numInputs={6}
        containerStyle={{ display: 'flex', gap: '5px' }}
        isInputNum
      />
    </Box>
  );
};
